import { render, staticRenderFns } from "./WelcomeCard.vue?vue&type=template&id=3888130d&scoped=true"
import script from "./WelcomeCard.vue?vue&type=script&lang=js"
export * from "./WelcomeCard.vue?vue&type=script&lang=js"
import style0 from "./WelcomeCard.vue?vue&type=style&index=0&id=3888130d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3888130d",
  null
  
)

export default component.exports